// Lot 728 — double tap sur une bulle du chat → ❤️ instantané (façon Messenger / Instagram).
// Deux taps simples (ni glissé, ni appui long) à moins de DOUBLE_TAP_MS d'écart et à moins de DOUBLE_TAP_PX l'un de l'autre.
export const DOUBLE_TAP_MS = 320;
export const DOUBLE_TAP_PX = 28;

export const isDoubleTap = (prev, cur) => !!prev && prev.at > 0 && cur.at - prev.at >= 0 && cur.at - prev.at < DOUBLE_TAP_MS
  && Math.hypot(cur.x - prev.x, cur.y - prev.y) < DOUBLE_TAP_PX;
